import gql from 'graphql-tag';

export const QUERY_LANDLORD_INFO = gql`
  query QueryLandlordInfo {
    viewer {
      ... on LandlordContact {
        company {
          accountDifferentiation
          isLongtail
          id
          status
          hasPropertyForKey
          bookings(opportunityStages: [COMPLETED, CANCELLATION, LOST]) {
            totalCount
          }
          hasIntegratedProperty
          herculesNoPaymentBookings: orders(
            bookingJourneys: SEMI_AUTOMATIC
            pageSize: 10
            pageNumber: 1
            paymentOnline: false
          ) {
            totalCount
          }
          leadGenAllOrders: orders(bookingJourneys: [LEAD_GENERATION]) {
            totalCount
          }
          instantNoPaymentBookings: orders(
            bookingJourneys: INSTANT_BOOK
            pageSize: 10
            pageNumber: 1
            paymentOnline: false
          ) {
            totalCount
          }
          instantBookings: orders(bookingJourneys: INSTANT_BOOK, pageSize: 10, pageNumber: 1) {
            totalCount
          }
          totalOrders: orders(pageNumber: 1, pageSize: 10) {
            totalCount
          }
        }
        id
        firstName
        lastName
        allProperties: properties(pageSize: 10, pageNumber: 1) {
          totalCount
        }
        manualProperties: properties(bookingJourneys: MANUAL, pageSize: 10, pageNumber: 1) {
          totalCount
        }
        herculesProperties: properties(
          bookingJourneys: SEMI_AUTOMATIC
          pageSize: 10
          pageNumber: 1
        ) {
          totalCount
        }
        yugoProperties: properties(bookingJourneys: FULL_AUTOMATIC, pageSize: 10, pageNumber: 1) {
          totalCount
        }
        instantProperties: properties(bookingJourneys: INSTANT_BOOK, pageSize: 10, pageNumber: 1) {
          totalCount
        }
        leadProperties: properties(bookingJourneys: LEAD_GENERATION, pageSize: 10, pageNumber: 1) {
          totalCount
        }
      }
    }
  }
`;
